/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateHierarchyUnitRequestDto } from '../models';
// @ts-ignore
import type { CreateHierarchyUnitResponseDto } from '../models';
// @ts-ignore
import type { DeleteHierarchyUnitResponseDto } from '../models';
// @ts-ignore
import type { NodeDeletionStrategyDto } from '../models';
// @ts-ignore
import type { SimulationTypeDto } from '../models';
/**
 * HierarchyUnitsManagerRestApi - axios parameter creator
 * @export
 */
export const HierarchyUnitsManagerRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new hierarchy unit node in the hierarchy.  Behavior based on input: - No parentId, no childIds: Creates root node (level = 1) - Only parentId: Creates leaf node under parent (level = parent.level + 1) - Both parentId and childIds: Inserts node between parent and specified children,   reassigns children to new node and updates their levels accordingly 
         * @summary Create Hierarchy Unit
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {SimulationTypeDto} simulationType Filter simulations by type
         * @param {CreateHierarchyUnitRequestDto} createHierarchyUnitRequestDto Create hierarchy unit request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHierarchyUnit: async (simulationId: string, simulationType: SimulationTypeDto, createHierarchyUnitRequestDto: CreateHierarchyUnitRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('createHierarchyUnit', 'simulationId', simulationId)
            // verify required parameter 'simulationType' is not null or undefined
            assertParamExists('createHierarchyUnit', 'simulationType', simulationType)
            // verify required parameter 'createHierarchyUnitRequestDto' is not null or undefined
            assertParamExists('createHierarchyUnit', 'createHierarchyUnitRequestDto', createHierarchyUnitRequestDto)
            const localVarPath = `/api/v2/organizational-units/simulations/{simulationId}`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (simulationType !== undefined) {
                localVarQueryParameter['simulationType'] = simulationType;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHierarchyUnitRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a hierarchy unit from the hierarchy simulation.  Deletion strategies: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
         * @summary Delete Hierarchy Unit
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {string} unitId 
         * @param {SimulationTypeDto} simulationType Filter simulations by type
         * @param {NodeDeletionStrategyDto} deletionStrategy Strategy for deleting the hierarchy node: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHierarchyUnit: async (simulationId: string, unitId: string, simulationType: SimulationTypeDto, deletionStrategy: NodeDeletionStrategyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deleteHierarchyUnit', 'simulationId', simulationId)
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('deleteHierarchyUnit', 'unitId', unitId)
            // verify required parameter 'simulationType' is not null or undefined
            assertParamExists('deleteHierarchyUnit', 'simulationType', simulationType)
            // verify required parameter 'deletionStrategy' is not null or undefined
            assertParamExists('deleteHierarchyUnit', 'deletionStrategy', deletionStrategy)
            const localVarPath = `/api/v2/organizational-units/{unitId}/simulations/{simulationId}`
                .replace(`{${"simulationId"}}`, encodeURIComponent(String(simulationId)))
                .replace(`{${"unitId"}}`, encodeURIComponent(String(unitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (simulationType !== undefined) {
                localVarQueryParameter['simulationType'] = simulationType;
            }

            if (deletionStrategy !== undefined) {
                localVarQueryParameter['deletionStrategy'] = deletionStrategy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HierarchyUnitsManagerRestApi - functional programming interface
 * @export
 */
export const HierarchyUnitsManagerRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HierarchyUnitsManagerRestApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new hierarchy unit node in the hierarchy.  Behavior based on input: - No parentId, no childIds: Creates root node (level = 1) - Only parentId: Creates leaf node under parent (level = parent.level + 1) - Both parentId and childIds: Inserts node between parent and specified children,   reassigns children to new node and updates their levels accordingly 
         * @summary Create Hierarchy Unit
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {SimulationTypeDto} simulationType Filter simulations by type
         * @param {CreateHierarchyUnitRequestDto} createHierarchyUnitRequestDto Create hierarchy unit request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHierarchyUnit(simulationId: string, simulationType: SimulationTypeDto, createHierarchyUnitRequestDto: CreateHierarchyUnitRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateHierarchyUnitResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHierarchyUnit(simulationId, simulationType, createHierarchyUnitRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchyUnitsManagerRestApi.createHierarchyUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a hierarchy unit from the hierarchy simulation.  Deletion strategies: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
         * @summary Delete Hierarchy Unit
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {string} unitId 
         * @param {SimulationTypeDto} simulationType Filter simulations by type
         * @param {NodeDeletionStrategyDto} deletionStrategy Strategy for deleting the hierarchy node: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHierarchyUnit(simulationId: string, unitId: string, simulationType: SimulationTypeDto, deletionStrategy: NodeDeletionStrategyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteHierarchyUnitResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHierarchyUnit(simulationId, unitId, simulationType, deletionStrategy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HierarchyUnitsManagerRestApi.deleteHierarchyUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HierarchyUnitsManagerRestApi - factory interface
 * @export
 */
export const HierarchyUnitsManagerRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HierarchyUnitsManagerRestApiFp(configuration)
    return {
        /**
         * Creates a new hierarchy unit node in the hierarchy.  Behavior based on input: - No parentId, no childIds: Creates root node (level = 1) - Only parentId: Creates leaf node under parent (level = parent.level + 1) - Both parentId and childIds: Inserts node between parent and specified children,   reassigns children to new node and updates their levels accordingly 
         * @summary Create Hierarchy Unit
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {SimulationTypeDto} simulationType Filter simulations by type
         * @param {CreateHierarchyUnitRequestDto} createHierarchyUnitRequestDto Create hierarchy unit request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHierarchyUnit(simulationId: string, simulationType: SimulationTypeDto, createHierarchyUnitRequestDto: CreateHierarchyUnitRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateHierarchyUnitResponseDto> {
            return localVarFp.createHierarchyUnit(simulationId, simulationType, createHierarchyUnitRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a hierarchy unit from the hierarchy simulation.  Deletion strategies: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
         * @summary Delete Hierarchy Unit
         * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
         * @param {string} unitId 
         * @param {SimulationTypeDto} simulationType Filter simulations by type
         * @param {NodeDeletionStrategyDto} deletionStrategy Strategy for deleting the hierarchy node: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHierarchyUnit(simulationId: string, unitId: string, simulationType: SimulationTypeDto, deletionStrategy: NodeDeletionStrategyDto, options?: RawAxiosRequestConfig): AxiosPromise<DeleteHierarchyUnitResponseDto> {
            return localVarFp.deleteHierarchyUnit(simulationId, unitId, simulationType, deletionStrategy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HierarchyUnitsManagerRestApi - interface
 * @export
 * @interface HierarchyUnitsManagerRestApi
 */
export interface HierarchyUnitsManagerRestApiInterface {
    /**
     * Creates a new hierarchy unit node in the hierarchy.  Behavior based on input: - No parentId, no childIds: Creates root node (level = 1) - Only parentId: Creates leaf node under parent (level = parent.level + 1) - Both parentId and childIds: Inserts node between parent and specified children,   reassigns children to new node and updates their levels accordingly 
     * @summary Create Hierarchy Unit
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {SimulationTypeDto} simulationType Filter simulations by type
     * @param {CreateHierarchyUnitRequestDto} createHierarchyUnitRequestDto Create hierarchy unit request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyUnitsManagerRestApiInterface
     */
    createHierarchyUnit(simulationId: string, simulationType: SimulationTypeDto, createHierarchyUnitRequestDto: CreateHierarchyUnitRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateHierarchyUnitResponseDto>;

    /**
     * Deletes a hierarchy unit from the hierarchy simulation.  Deletion strategies: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
     * @summary Delete Hierarchy Unit
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {string} unitId 
     * @param {SimulationTypeDto} simulationType Filter simulations by type
     * @param {NodeDeletionStrategyDto} deletionStrategy Strategy for deleting the hierarchy node: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyUnitsManagerRestApiInterface
     */
    deleteHierarchyUnit(simulationId: string, unitId: string, simulationType: SimulationTypeDto, deletionStrategy: NodeDeletionStrategyDto, options?: RawAxiosRequestConfig): AxiosPromise<DeleteHierarchyUnitResponseDto>;

}

/**
 * HierarchyUnitsManagerRestApi - object-oriented interface
 * @export
 * @class HierarchyUnitsManagerRestApi
 * @extends {BaseAPI}
 */
export class HierarchyUnitsManagerRestApi extends BaseAPI implements HierarchyUnitsManagerRestApiInterface {
    /**
     * Creates a new hierarchy unit node in the hierarchy.  Behavior based on input: - No parentId, no childIds: Creates root node (level = 1) - Only parentId: Creates leaf node under parent (level = parent.level + 1) - Both parentId and childIds: Inserts node between parent and specified children,   reassigns children to new node and updates their levels accordingly 
     * @summary Create Hierarchy Unit
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {SimulationTypeDto} simulationType Filter simulations by type
     * @param {CreateHierarchyUnitRequestDto} createHierarchyUnitRequestDto Create hierarchy unit request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyUnitsManagerRestApi
     */
    public createHierarchyUnit(simulationId: string, simulationType: SimulationTypeDto, createHierarchyUnitRequestDto: CreateHierarchyUnitRequestDto, options?: RawAxiosRequestConfig) {
        return HierarchyUnitsManagerRestApiFp(this.configuration).createHierarchyUnit(simulationId, simulationType, createHierarchyUnitRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a hierarchy unit from the hierarchy simulation.  Deletion strategies: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
     * @summary Delete Hierarchy Unit
     * @param {string} simulationId Simulation ID to get hierarchy from simulation. - If empty: returns live version (current hierarchy structure) - If provided: returns hierarchy from the specified simulation 
     * @param {string} unitId 
     * @param {SimulationTypeDto} simulationType Filter simulations by type
     * @param {NodeDeletionStrategyDto} deletionStrategy Strategy for deleting the hierarchy node: - DELETE_WITH_CHILDREN: Removes node and all its descendants (irreversible) - DELETE_AND_PROMOTE_CHILDREN: Removes node but promotes children to parent level - CONVERT_EMPLOYEE_TO_VACANCY: Converts employee node to vacancy (only for EMPLOYEE nodes) 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HierarchyUnitsManagerRestApi
     */
    public deleteHierarchyUnit(simulationId: string, unitId: string, simulationType: SimulationTypeDto, deletionStrategy: NodeDeletionStrategyDto, options?: RawAxiosRequestConfig) {
        return HierarchyUnitsManagerRestApiFp(this.configuration).deleteHierarchyUnit(simulationId, unitId, simulationType, deletionStrategy, options).then((request) => request(this.axios, this.basePath));
    }
}

